import { ApplierOption } from '../../../lib/helpers/ApplierOption';
import { SvgParcelReturn } from '@parcel2go/core-ui';
import { SvgArrowLeftCircle } from '@parcel2go/core-ui';
import { SvgExport } from '@parcel2go/core-ui';
import { SvgSmartSend } from '@parcel2go/core-ui';
import { SvgAdd } from '@parcel2go/core-ui';
import { SvgEmail } from '@parcel2go/core-ui';
import { SvgMaxDimensions } from '@parcel2go/core-ui';
import { SvgQuotes } from '@parcel2go/core-ui';
import { SvgActions } from '@parcel2go/core-ui';
import { SvgParcelLabel } from '@parcel2go/core-ui';
import { SvgParcel } from '@parcel2go/core-ui';
import { SvgVanCheck } from '@parcel2go/core-ui';
import { SvgRefresh } from '@parcel2go/core-ui';
import { SvgCalendarOneDay } from '@parcel2go/core-ui';
import { SvgLabelPrinting4X6 } from '@parcel2go/core-ui';
import { SvgArchive } from '@parcel2go/core-ui';
import { SvgDelete } from '@parcel2go/core-ui';
import { SvgSignature } from '@parcel2go/core-ui';
import { SvgProtectionAdd } from '@parcel2go/core-ui';

export function GetBulkActionIcon(type: ApplierOption) {
  switch (type) {
    case 'Status:Active':
      return <SvgParcelReturn />;
    case 'Status:Deleted':
      return <SvgDelete />;
    case 'Status:Archived':
      return <SvgArchive />;
    case 'Status:Inactive':
      return <SvgArrowLeftCircle />;
    case 'Download:CSV:Booked':
    case 'Download:CSV:Orders':
    case 'Download:CSV:Sold':
      return <SvgExport />;
    case 'Download:PickingList':
      return <SvgSmartSend />;
    case 'MarkAsPackaged':
      return <SvgParcelLabel />;
    case 'Dispatch':
    case 'Dispatch:Confirm':
      return <SvgVanCheck />;
    case 'Download:Labels':
      return <SvgLabelPrinting4X6 />;
    case 'MarkAsNotPackaged':
      return <SvgParcel />;
    case 'Tags':
      return <SvgAdd />;
    case 'RecipientContactDetails:Add':
    case 'RecipientContactDetails:Change':
      return <SvgEmail />;
    case 'Dimensions:Add':
    case 'Dimensions:Change':
      return <SvgMaxDimensions />;
    case 'Protection':
      return <SvgProtectionAdd />;
    case 'Extras':
      return <SvgSignature />;
    case 'Service:Add':
    case 'Service:Change':
      return <SvgQuotes />;
    case 'Return':
      return <SvgRefresh />;
    case 'PreferredCollectionDate':
      return <SvgCalendarOneDay />;
    case 'LIST':
      return <SvgActions />;
    case 'TariffCodes:Add':
      return <SvgActions />;
    default:
      return <SvgActions />;
  }
}

export function GetBulkActionIconSrc(type: ApplierOption): string {
  switch (type) {
    case 'Status:Active':
      return '/theme/icons/ParcelReturn.svg';
    case 'Status:Deleted':
      return '/theme/icons/Delete.svg';
    case 'Status:Archived':
      return '/theme/icons/Archive.svg';
    case 'Status:Inactive':
      return '/theme/icons/ArrowLeftCircle.svg';
    case 'Download:CSV:Booked':
    case 'Download:CSV:Orders':
    case 'Download:CSV:Sold':
      return '/theme/icons/Export.svg';
    case 'Download:PickingList':
      return '/theme/icons/SmartSend.svg';
    case 'MarkAsPackaged':
      return '/theme/icons/ParcelLabel.svg';
    case 'Dispatch':
    case 'Dispatch:Confirm':
      return '/theme/icons/VanCheck.svg';
    case 'MarkAsNotPackaged':
      return '/theme/icons/Parcel.svg';
    case 'Tags':
      return '/theme/icons/Add.svg';
    case 'RecipientContactDetails:Add':
    case 'RecipientContactDetails:Change':
      return '/theme/icons/Email.svg';
    case 'Dimensions:Add':
    case 'Dimensions:Change':
      return '/theme/icons/MaxDimensions.svg';
    case 'Protection':
    case 'Extras':
      return '/theme/icons/Protection.svg';
    case 'Service:Add':
    case 'Service:Change':
      return '/theme/icons/Quotes.svg';
    case 'Return':
      return '/theme/icons/Refresh.svg';
    case 'TariffCodes:Add':
      return '/theme/icons/Actions.svg';
    case 'LIST':
      return '/theme/icons/Actions.svg';
    default:
      return '/theme/icons/Actions.svg';
  }
}
